import { images } from '../../assets/images';

const apps = [
  {
    id: 1,
    title: 'Industrial Motors',
    image: images.applications.motors
  },
  {
    id: 2,
    title: 'Home Appliances',
    image: images.applications.fans
  },
  {
    id: 3,
    title: 'Commercial Lighting',
    image: images.applications.lighting
  },
  {
    id: 4,
    title: 'Agriculture',
    image: images.applications.agriculture
  }
];

const Applications = () => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-bold uppercase tracking-wider text-sm">Industries We Serve</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2">Applications</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {apps.map((app) => (
            <div key={app.id} className="relative group overflow-hidden rounded-lg h-64">
              <img 
                src={app.image} 
                alt={app.title} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent flex items-end p-6">
                <h3 className="text-white text-xl font-bold translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  {app.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Applications;
